import React, { FunctionComponent } from 'react'
import styled from 'styled-components'

import { mediaMax } from 'styles/media'

import InfoParagraph from './InfoParagraph'

const Step = styled.div<{ reverse?: boolean }>`
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
  align-items: center;
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 120px;
    ${mediaMax.md`
      margin-bottom: 40px;
    `}
  }

  ${mediaMax.md`
    flex-direction: column;
    align-items: flex-start;
    margin-top: 0;
    height: auto;
  `}

  & > * {
    width: 50%;
    ${mediaMax.md`
      width: 100%;
    `}
  }

  & > *:not(:first-child) {
    margin-top: 40px;
  }

  svg {
    transform: scale(0.7);

    ${mediaMax.md`
      transform: none;
      height: 120px;
      width: unset;
    `}
  }
`

const StepsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1000px;
`

export type Steps = Array<{
  title: string
  explanation: React.ReactNode
  IllustrationComponent: React.FC<any>
}>

type IllustratedStepsProps = {
  steps: Steps
}

const IllustratedSteps: FunctionComponent<IllustratedStepsProps> = ({
  steps,
}) => {
  return (
    <StepsWrapper>
      {steps.map(({ title, explanation, IllustrationComponent }, index) => {
        const reverse = index % 2 !== 0
        return (
          <Step reverse={reverse}>
            <IllustrationComponent />
            <InfoParagraph heading={title} text={explanation} />
          </Step>
        )
      })}
    </StepsWrapper>
  )
}

export default IllustratedSteps
